export default {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  inputContainer: {
    position: 'relative',
    width: '100%',
  },
  error: {
    position: 'absolute',
    color: (theme) => theme.palette.reds.codingRed400,
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  helperWithError: {
    marginTop: '16px',
  },
};
